import React from "react";
import "./PrivacyPolicy.css";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p>Last updated: June 29, 2025</p>

      <p>
        Blockcode LLC ("we", "our", or "us") is committed to protecting your privacy.
        This Privacy Policy explains how your personal information is collected, used,
        and disclosed when you use our website and services. If you do not agree to this
        policy, please do not access or use the website.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li>Personal Information (e.g., email, username)</li>
        <li>Authentication data from third-party logins (e.g., Discord, Google)</li>
        <li>Usage data (pages visited, time spent, actions taken)</li>
        <li>Technical data (IP address, browser type, device info)</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Provide and improve our services</li>
        <li>Personalize your learning experience</li>
        <li>Track user progress and usage analytics</li>
        <li>Send important updates or service notifications</li>
      </ul>

      <h2>3. Sharing Your Information</h2>
      <p>We do not sell your personal information. We may share your data with:</p>
      <ul>
        <li>Service providers (e.g., payment processors, analytics tools)</li>
        <li>Law enforcement when required by law</li>
        <li>
          Other users, only when you explicitly choose to share data (e.g., public
          leaderboards)
        </li>
      </ul>

      <h2>4. Cookies & Tracking</h2>
      <p>
        We use cookies and similar technologies to track usage, save preferences, and
        enhance performance.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We take reasonable steps to protect your personal data, but no system is 100%
        secure. Always use a strong password and log out after use.
      </p>

      <h2>6. Your Choices</h2>
      <ul>
        <li>You can request to delete your account at any time.</li>
        <li>You may opt out of non-essential emails.</li>
        <li>You may access or update your information in your account settings.</li>
      </ul>

      <h2>7. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify users that
        changes have been made by indicating on the policy the last date that changes
        have been made.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please{" "}
        <Link to="/contactus">contact us</Link>.
      </p>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
